import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICopyButton from 'UIComponents/button/UICopyButton';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import { PANTERA } from 'HubStyleTokens/colors';
import { mediaQueries } from '../../utils/mediaQueries';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledMediaBar = styled(UIMediaObject).withConfig({
  displayName: "MediaBar__StyledMediaBar",
  componentId: "mb55et-0"
})(["padding:8px 0;background-color:", ";width:100%;", "{padding-left:44px;}"], PANTERA, mediaQueries.aboveLaptop);
const StyledCopyButton = styled(UICopyButton).withConfig({
  displayName: "MediaBar__StyledCopyButton",
  componentId: "mb55et-1"
})(["&&&{font-size:14px;font-weight:400;}"]);
const MediaBar = ({
  children,
  onCopyValue,
  value = ''
}) => {
  return /*#__PURE__*/_jsx(StyledMediaBar, {
    itemRight: /*#__PURE__*/_jsx(StyledCopyButton, {
      use: "link-on-dark",
      className: "p-x-2",
      value: value,
      onClick: onCopyValue,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-shared-components.codeSample.copyAll"
      })
    }),
    children: children
  });
};
export default MediaBar;